import { UserIdentityResource } from 'dy-frontend-http-repository/lib/modules/User/resources';
import domain from './domain';
import { resetUserIdentity } from './events';

// User identity
export const $userIdentity = domain.createStore<UserIdentityResource | null>(null).reset(resetUserIdentity);
